var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 28,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-1150 -585)",
    fill: "#180045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -171.552,
    cy: -247.302,
    rx: 147.552,
    ry: 137.698,
    fill: "#C206F1",
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 188",
    filter: "url(#filter1_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -602,
    y: -26,
    width: 825,
    height: 78,
    rx: 8,
    fill: "url(#paint0_linear_0_1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 189",
    d: "M-23 -6C-23 -10.4183 -19.4183 -14 -15 -14H181C185.418 -14 189 -10.4183 189 -6V32C189 36.4183 185.418 40 181 40H-15C-19.4183 40 -23 36.4183 -23 32V-6Z",
    fill: "url(#paint1_linear_0_1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.9998 13.5538C32.8063 13.8449 32.5402 13.9499 32.187 13.9355C30.6775 13.883 29.1826 13.9737 27.7312 14.4223C24.9784 15.2718 23.1641 17.0901 22.1675 19.7341C21.6014 21.2279 21.4031 22.7885 21.3983 24.3729C21.3983 24.5209 21.4031 24.6688 21.3934 24.8167C21.3692 25.1365 21.1418 25.356 20.837 25.3704C20.5419 25.3847 20.2613 25.1795 20.2323 24.874C20.1936 24.4731 20.2081 24.0722 20.1888 23.6666C20.1162 21.7671 19.7001 19.9584 18.7615 18.288C18.6164 18.0303 18.4422 17.7869 18.2923 17.5292C18.1278 17.2476 18.1761 16.9851 18.4084 16.8324C18.6503 16.6749 18.9309 16.7465 19.1244 17.0329C19.884 18.1401 20.4065 19.3475 20.7451 20.6361C20.7548 20.6743 20.7693 20.7172 20.8032 20.8365C21.7901 16.9995 24.0398 14.408 27.9973 13.3342C24.0398 12.2795 21.8192 9.67374 20.8129 5.8176C19.8066 9.6642 17.5859 12.2652 13.6865 13.3247C14.2429 13.5299 14.7944 13.6826 15.2927 13.9355C16.0136 14.303 16.6957 14.7421 17.3827 15.1716C17.6536 15.3434 17.6972 15.6393 17.5375 15.8636C17.3682 16.1022 17.0973 16.1213 16.8022 15.9448C16.1297 15.5391 15.4717 15.0857 14.7654 14.7516C13.4978 14.1551 12.1238 13.9737 10.7305 13.9355C10.2467 13.9212 9.76286 13.9355 9.27906 13.9308C8.87751 13.926 8.62109 13.6874 8.62109 13.3438C8.62109 12.9954 8.86783 12.7615 9.27422 12.7472C10.1451 12.7186 11.0159 12.752 11.8771 12.6565C15.3411 12.2747 17.8762 10.5853 19.2695 7.37819C19.9227 5.8701 20.2081 4.28564 20.2033 2.64869C20.2033 2.37189 20.1936 2.09508 20.2275 1.82305C20.271 1.49375 20.5468 1.28377 20.8516 1.30763C21.1612 1.33149 21.3886 1.57011 21.3983 1.90418C21.4224 2.50551 21.4128 3.11162 21.466 3.71295C21.6402 5.74124 22.2159 7.64068 23.4496 9.29672C24.7413 11.0291 26.512 12.0266 28.6262 12.4752C29.7922 12.7233 30.9678 12.7568 32.1483 12.7329C32.5063 12.7233 32.7966 12.814 33.0046 13.1099V13.5538H32.9998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.7358 5.42151C6.66177 4.9204 5.9651 4.15204 5.51032 3.1021C5.05071 4.13772 4.3492 4.91086 3.28001 5.41674C4.32985 5.92262 5.04104 6.68144 5.49581 7.72183C5.57806 7.57866 5.63127 7.45935 5.70384 7.35435C5.83931 7.15391 6.03283 7.07755 6.26505 7.15868C6.50695 7.24459 6.61339 7.43071 6.57468 7.68365C6.56017 7.77433 6.53114 7.86978 6.4876 7.95568C6.15378 8.66201 6.04734 9.40651 6.03767 10.1796C6.03767 10.3419 6.0038 10.5519 5.9022 10.6426C5.77158 10.7571 5.54419 10.8335 5.37002 10.8192C5.10877 10.7953 4.98782 10.5805 4.96847 10.3181C4.92493 9.83603 4.92493 9.34447 4.82817 8.86722C4.46048 7.0871 3.15422 6.01807 1.31578 5.96557C1.06904 5.9608 0.822302 5.94648 0.575564 5.93216C0.193362 5.91785 -0.00983402 5.72218 -0.000158019 5.40242C0.014356 5.08267 0.227228 4.90609 0.614268 4.90609C1.29159 4.90609 1.96891 4.87745 2.61236 4.63883C3.89443 4.17113 4.57175 3.21186 4.82817 1.93284C4.91525 1.49855 4.9346 1.04994 4.96363 0.610874C4.99266 0.214761 5.17166 0 5.50549 0C5.83931 0 6.03767 0.224305 6.03767 0.620419C6.03767 1.6799 6.23602 2.68212 6.88432 3.55548C7.47455 4.34771 8.30669 4.71996 9.26945 4.83927C9.64198 4.887 10.0193 4.89177 10.3919 4.90131C10.7741 4.91563 10.9966 5.08744 11.0063 5.40242C11.016 5.72218 10.7837 5.91307 10.3919 5.95125C9.75325 6.0133 9.11947 6.08488 8.48569 6.18033C8.2825 6.21374 8.08898 6.33782 7.89062 6.41418C7.60518 6.51918 7.34393 6.43327 7.22781 6.20419C7.1117 5.97034 7.20362 5.71263 7.46004 5.55514C7.52293 5.51696 7.59066 5.48833 7.72613 5.41674L7.7358 5.42151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.0889 20.2639C10.6148 21.3186 9.91808 22.0774 8.8634 22.5737C9.91324 23.0748 10.6244 23.8337 11.0937 24.8931C11.5582 23.8337 12.2597 23.0701 13.3047 22.5833C13.2176 22.5308 13.1741 22.5021 13.1305 22.4783C12.8112 22.2921 12.7096 22.0583 12.8354 21.8054C12.966 21.5429 13.2224 21.4904 13.5853 21.6192C13.9868 21.7624 14.3932 21.9104 14.8093 21.9867C15.1963 22.0583 15.6027 22.0344 15.9994 22.0535C16.3865 22.0726 16.6042 22.2587 16.6042 22.569C16.6042 22.8935 16.372 23.0891 15.9753 23.0891C15.1576 23.0891 14.3449 23.1464 13.595 23.5234C12.4725 24.0866 11.95 25.0602 11.7372 26.2247C11.6598 26.6399 11.6452 27.0646 11.6114 27.4846C11.5824 27.8234 11.4033 28 11.084 27.9952C10.7744 27.9905 10.6002 27.8043 10.5664 27.4703C10.518 26.9548 10.5132 26.4299 10.3874 25.9335C9.92292 24.1248 8.8005 23.2323 6.90885 23.113C6.65243 23.0987 6.39602 23.0987 6.13477 23.0891C5.80578 23.0796 5.60259 22.8839 5.59775 22.5833C5.59291 22.2778 5.78159 22.0917 6.11541 22.0583C6.75403 21.9915 7.412 22.001 8.02159 21.834C9.45847 21.4379 10.1793 20.3832 10.4406 18.9896C10.5228 18.5553 10.5373 18.1067 10.5712 17.6629C10.5954 17.367 10.7938 17.1522 11.0647 17.1379C11.355 17.1236 11.6065 17.3336 11.6065 17.6438C11.6065 18.5315 11.7614 19.3857 12.1387 20.2018C12.2597 20.4595 12.1484 20.7125 11.921 20.827C11.684 20.9463 11.4179 20.8556 11.263 20.6027C11.2098 20.512 11.1663 20.4166 11.0889 20.2639Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: -469.104,
    y: -535,
    width: 595.103,
    height: 575.396,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_0_1",
    x: -702,
    y: -126,
    width: 1025,
    height: 278,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: -189.5,
    y1: -26,
    x2: -189.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: -23,
    y1: 13.4737,
    x2: 191.831,
    y2: 13.4737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#379EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-1150 -585)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.978c28484031860ec846f0abfb29ec5d.svg";
export { ForwardRef as ReactComponent };